import { admin2 } from './instance'

export const GetLineLoginConfig = async ({
  shopId,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/lineLoginConfig`,
  })
}

export const GetLineLoginConfigRedirectUrl = async ({
  shopId,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/lineLoginConfig/redirectUrl`,
  })
}

export const UpdateLineLoginConfig = async ({
  shopId,
  channelId,
  channelSecret,
  enableLoginBotLink,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/lineLoginConfig`,
    data: {
      channelId,
      channelSecret,
      enableLoginBotLink,
    },
  })
}

/**
 * 取得 Line 綁定設定
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @returns {import('@/api/instance').Api2Response<{
 *   id: string,
 *   enabledJoinFriend: boolean,
 *   requiredJoinFriend: boolean,
 *   bindLineVisibleMaskPhone: boolean,
 *   requiredLineBindingForEcommerce: boolean,
 *   createdAt: string,
 *   updatedAt: string,
 *   ShopId: string
 * }>}
 */
export const GetLineBindingConfig = async ({
  shopId,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/lineBindingSetting`,
  })
}

/**
 * 更新 Line 綁定設定
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {boolean} params.enabledJoinFriend - 是否啟用加入好友提醒
 * @param {boolean} params.requiredJoinFriend - 是否限制 Line 綁定會員才可使用系統服務
 * @param {boolean} params.bindLineVisibleMaskPhone - 是否套用電話隱碼
 * @param {boolean} params.requiredLineBindingForEcommerce - 是否限制 LINE 綁定才可使用電商服務
 * @returns {import('@/api/instance').Api2Response<{
 *   id: string,
 *   enabledJoinFriend: boolean,
 *   requiredJoinFriend: boolean,
 *   bindLineVisibleMaskPhone: boolean,
 *   requiredLineBindingForEcommerce: boolean,
 *   createdAt: string,
 *   updatedAt: string,
 *   ShopId: string
 * }>}
 */
export const UpdateLineBindingConfig = async ({
  shopId,
  enabledJoinFriend,
  requiredJoinFriend,
  bindLineVisibleMaskPhone,
  requiredLineBindingForEcommerce,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/lineBindingSetting`,
    data: {
      enabledJoinFriend,
      requiredJoinFriend,
      bindLineVisibleMaskPhone,
      requiredLineBindingForEcommerce,
    },
  })
}

export const CheckLineQuota = async ({
  shopId,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/lineConfig/checkQuota`,
  })
}

export const GetLineWebhookUrl = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/lineConfig/getWebhookUrl`,
  })
}
